import React from 'react'
import PropTypes from 'prop-types'
import { components } from 'react-select'

const DropdownIndicator = (props) => {
  const { selectProps } = props
  const { menuIsOpen } = selectProps

  const iconClassName = menuIsOpen
    ? 'fas fa-sort-up community-select-field__dropdown-indicator--arrow-up-position'
    : 'fas fa-sort-down'

  return (
    <components.DropdownIndicator {...props}>
      <i className={iconClassName} />
    </components.DropdownIndicator>
  )
}

DropdownIndicator.propTypes = {
  selectProps: PropTypes.shape({
    menuIsOpen: PropTypes.bool,
  }),
}

DropdownIndicator.defaultProps = {
  selectProps: {
    menuIsOpen: false,
  },
}

export default DropdownIndicator
